module.exports = __webpack_public_path__ + "img/ASTRONERGY-icon.55bc1b85.png";